var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.token && _vm.$route.path != '/register' && _vm.$route.path != '/login')?_c('div',{staticClass:"header"},[_c('header-top')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }